// extracted by mini-css-extract-plugin
module.exports = {"container":"container-1bpWI","title":"title-AHbko","body":"body-2Oiwz","host":"host-2IjDJ","footer":"footer-3CRnS","price":"price-3djS_"};